<app-layout-crud-index table>
  <div fxLayout="column" table fxLayoutAlign="space-between center" fxFill
    class="container-padding">
    <!-- Cabeçalho com título e status -->
    <div fxFlex="3" fxFill fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="10"></div>
      <div fxFlex fxLayoutAlign="center">
        <h1 mat-dialog-title>{{ title }}</h1>
      </div>
      <div fxFlex="10" fxLayoutAlign="end">
        <app-input [config]="getFieldConfig('isActive')" [typeCes]="typeCes"
          [group]="form"></app-input>
      </div>
    </div>

    <div fxFlex fxLayout="row" fxFill fxLayoutGap="8">

      <div fxFlex="70" fxLayout="column" fxLayoutGap="8">
        <mat-card fxFlex="40">
          <mat-card-header>
            <mat-card-title>Cadastro</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="column" fxLayoutGap="4">
              <div fxFlex fxLayout="row" fxLayoutGap="8">
                <app-input class="image-container" fxFlex="20"
                  [config]="getFieldConfig('image')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <div fxFlex="80" fxLayout="column" fxLayoutGap="4">

                  <div fxFlex fxLayout="row" fxLayoutGap="8">
                    <app-input fxFlex="15"
                      [config]="getFieldConfig('legalPersonality')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                      fxFlex="13"
                      [config]="getFieldConfig('cpf')" [typeCes]="typeCes"
                      [group]="form" (onBlur)="onBlur($event)"></app-input>
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                      fxFlex
                      [config]="getFieldConfig('name')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                      fxFlex="15"
                      [config]="getFieldConfig('cnpj')" [typeCes]="typeCes"
                      [group]="form" (onChange)="onChangeCnpj()"
                      (onBlur)="onBlur($event)"></app-input>
                    <app-input
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                      fxFlex
                      [config]="getFieldConfig('companyName')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input fxFlex="22"
                      [config]="getFieldConfig('birthday')" [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>

                  <div fxFlex fxLayout="row" fxLayoutGap="8">
                    <app-input [fxFlex]="35"
                      [config]="getFieldConfig('tradingName')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input fxFlex
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_FISICA)"
                      [config]="getFieldConfig('generalRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input fxFlex
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                      [config]="getFieldConfig('stateRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input fxFlex
                      *ngIf="getLegalPersonality(legalPersonalityEnum.PESSOA_JURIDICA)"
                      [config]="getFieldConfig('municipalRegistration')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                  </div>

                  <div fxFlex fxLayout="row" fxLayoutGap="8">
                    <app-input fxFlex [config]="getFieldConfig('cellPhone')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                    <app-input fxFlex [config]="getFieldConfig('phone')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input fxFlex [config]="getFieldConfig('email')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                    <app-input fxFlex [config]="getFieldConfig('webSite')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>

                  <div fxFlex fxLayout="row" fxLayoutGap="8">
                    <app-input fxFlex [config]="getFieldConfig('regime')"
                      [typeCes]="typeCes" [group]="form"></app-input>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card fxFlex="30">
          <mat-card-header>
            <mat-card-title>Endereço</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="column" fxLayoutGap="4">

              <div fxLayout="row" fxLayoutGap="8">
                <app-input fxFlex="10" [config]="getFieldConfig('cep')"
                  [typeCes]="typeCes" [group]="form"
                  (onChange)="onChangeCep()"></app-input>
                <app-input fxFlex [config]="getFieldConfig('address')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
                <app-input fxFlex="10"
                  [config]="getFieldConfig('addressNumber')"
                  [typeCes]="typeCes"
                  [group]="form"></app-input>
              </div>

              <div fxLayout="row" fxLayoutGap="8">
                <app-input-text fxFlex
                  [config]="getFieldConfig('addressComplement')"
                  [group]="form"></app-input-text>
                <app-input-text fxFlex="25"
                  [config]="getFieldConfig('neighborhood')"
                  [group]="form"></app-input-text>
              </div>

              <div fxLayout="row" fxLayoutGap="8">
                <app-input fxFlex="15" [config]="getFieldConfig('state')"
                  [typeCes]="typeCes" [group]="form"
                  (onSelect)="onChangeState($event)"></app-input>
                <app-input fxFlex="25" [config]="getFieldConfig('city')"
                  [typeCes]="typeCes" [group]="form"></app-input>
                <app-input-text fxFlex
                  [config]="getFieldConfig('addressObservation')"
                  [group]="form"></app-input-text>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card fxFlex="30">
          <mat-card-header>
            <mat-card-title>Configurações e Login</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="row" fxLayoutGap="16">

              <div fxFlex="30" class="login-image-container">
                <app-input
                  [config]="getFieldConfig('loginScreenLogo')"
                  [typeCes]="typeCes"
                  [group]="form"
                  class="login-image-selector"></app-input>
              </div>

              <div fxFlex="70" fxLayout="column" fxLayoutGap="8">

                <div fxFlex fxLayout="row" fxLayoutGap="8"
                  fxLayoutAlign="start center">
                  <div fxFlex="40">
                    <app-input
                      [config]="getFieldConfig('cutoffDay')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                  <div fxFlex="40">
                    <app-input
                      [config]="getFieldConfig('transferDay')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                  <button
                    fxFlex="auto"
                    class="businessHours-button"
                    type="button"
                    (click)="openDialogBusinessHours()"
                    variant="contained"
                    mat-raised-button
                    title="Horário de Atendimento">
                    <mat-icon matSuffix>access_time</mat-icon>
                  </button>
                </div>

                <div fxFlex fxLayout="row" fxLayoutGap="8">
                  <div fxFlex>
                    <app-input
                      [config]="getFieldConfig('supportContact')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                  <div fxFlex>
                    <app-input
                      [config]="getFieldConfig('webSiteLink')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                </div>

                <div fxFlex fxLayout="row">
                  <app-input fxFlex
                    [config]="getFieldConfig('comment')"
                    [typeCes]="typeCes"
                    [group]="form"></app-input>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div fxFlex="30" fxLayout="column" fxLayoutGap="8">
        <mat-card fxFlex="65" class="compact-card">
          <mat-card-header>
            <mat-card-title>Tipos e Comissões</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <div class="section-block">
              <div fxFlex fxLayout="column">
                <div class="commission-row" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="0">
                  <div fxFlex="40" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isConsultant')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>
                  <div fxFlex="60" fxLayoutAlign="stretch">
                    <app-input fxFlex
                      [config]="getFieldConfig('consultantCommission')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                </div>

                <div class="commission-row" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="0">
                  <div fxFlex="40" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isPartner')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>
                  <div fxFlex="60" fxLayoutAlign="stretch">
                    <app-input fxFlex
                      [config]="getFieldConfig('partnerCommission')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                </div>

                <div class="commission-row" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="0">
                  <div fxFlex="40" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isRepresentative')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>
                  <div fxFlex="60" fxLayoutAlign="stretch">
                    <app-input fxFlex
                      [config]="getFieldConfig('representativeCommission')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                </div>

                <div class="commission-row" fxLayout="row"
                  fxLayoutAlign="start center" fxLayoutGap="0">
                  <div fxFlex="40" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isCounter')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>
                  <div fxFlex="60" fxLayoutAlign="stretch">
                    <app-input fxFlex
                      [config]="getFieldConfig('counterCommission')"
                      [typeCes]="typeCes"
                      [group]="form"></app-input>
                  </div>
                </div>

                <div class="other-types-container" fxLayout="column"
                  fxLayoutGap="4">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isUnit')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isSupplier')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start center">
                    <app-input fxFlex
                      [config]="getFieldConfig('isResale')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="start center" >
                    <app-input fxFlex
                      [config]="getFieldConfig('isMerchant')"
                      [typeCes]="typeCes"
                      [group]="form" class="type-checkbox"></app-input>
                    <button *ngIf="showModalMerchant"
                      class="custom-button btn-save" type="button"
                      variant="contained"
                      mat-raised-button
                     [disabled]="form.invalid"
                      (click)="modalMerchant()">
                    DADOS DO COMERCIANTE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card fxFlex="30">
          <mat-card-header>
            <mat-card-title>Vínculos</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div fxFlex fxLayout="column" fxLayoutGap="8">
              <app-input
                [fxShow]="form.get('isPartner')?.getRawValue() || form.get('isRepresentative')?.getRawValue()"
                fxFlex
                [config]="getFieldConfig('consultant')"
                [typeCes]="typeCes"
                [group]="form"
                (onSelect)="selectConsultant($event)"
                class="consultant"></app-input>
              <app-input
                [fxShow]="form.get('isRepresentative')?.getRawValue()"
                fxFlex
                [config]="getFieldConfig('partner')"
                [typeCes]="typeCes"
                [group]="form"
                (onSelect)="selectPartner($event)"
                class="partner"></app-input>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center"
      style="width: 100%; margin-top: auto;" fxLayoutGap="8">
      <div fxFlex="initial" class="info-title">DATA CADASTRO</div>
      <div fxFlex="initial" class="info-value">
        {{ getCreatedAt() | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <ng-container *ngIf="typeCes === typeCesEnum.EDIT">
        <app-input class="dateEdit" fxFlex="1"
          [config]="getFieldConfig('createdAt')" [typeCes]="typeCes"
          [group]="form">
        </app-input>
      </ng-container>

      | &nbsp;
      <div fxFlex="initial" class="info-title">ÚLTIMA ALTERAÇÃO</div>
      <div fxFlex="initial" class="info-value">
        {{ getUpdatedAt() | date : "dd/MM/yyyy HH:mm" }}
      </div>
      <ng-container *ngIf="typeCes === typeCesEnum.EDIT">
        <app-input class="dateEdit" fxFlex="1"
          [config]="getFieldConfig('updatedAt')" [typeCes]="typeCes"
          [group]="form">
        </app-input>
      </ng-container>
      | &nbsp;
      <div fxFlex="initial">
        <button matRipple class="pdf-button">
          <mat-icon>picture_as_pdf</mat-icon>
        </button>
      </div>

      <button class="custom-button" type="button" (click)="back()"
        mat-raised-button>
        VOLTAR
      </button>
      <button *ngIf="typeCes !== typeCesEnum.SHOW"
        class="custom-button btn-save" type="submit" variant="contained"
        mat-raised-button [disabled]="form.invalid"
        (click)="save()">
        SALVAR
      </button>
      <button
        *ngIf="typeCes === typeCesEnum.SHOW"
        class="custom-button btn-edit" type="submit" variant="contained"
        mat-raised-button (click)="edit()">
        EDITAR
      </button>
    </div>
  </div>
</app-layout-crud-index>